module.exports = __webpack_public_path__ + "img/tyguy.0883aa3d.svg";